import {CartItem} from 'lib/cart/types'

export const getCartItemID = (item: CartItem) =>
  item.variants.map((v) => v.value).join('') + item.product.id
